export const XFLOW_NODE_SHAPE = 'XFLOW_FLOW_NODE_SHAPE';
export const NODE_DEFAULT_WIDTH = 150;
export const NODE_DEFAULT_HEIGHT = 60;
//# sourceMappingURL=constants.js.map